import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReviewerStatus } from '../model/reviewerStatus';
import { TaskService } from '../services/tasks.service';

@Component({
  selector: 'app-reviewerspertask',
  templateUrl: './reviewerspertask.component.html',
  styleUrls: ['./reviewerspertask.component.css']
})
export class ReviewerspertaskComponent {
  reviewersStatusperTask: ReviewerStatus[] = [];
  @Input() requestId?: number;
  @Input() requirementId?: number;
  isListloading = false;
  requestSubscription?: Subscription;
  constructor(private readonly taskService: TaskService) {
  }
  ngOnInit(): void {
    this.getReviewerStatus();
  }

  getReviewerStatus() {
    this.isListloading = true;
    this.requestSubscription = this.taskService.getReviewerStatus(Number(this.requestId), Number(this.requirementId)).subscribe({
      next: (response) => { this.reviewersStatusperTask = response; this.isListloading = false; },
      error: (error) => { this.isListloading = false; },
      complete: () => { }
    })
  }

  ngOnDestroy(): void {
    this.requestSubscription?.unsubscribe();
  }
  getCSSColorStatus(approvalStatus: string): string {
    return this.taskService.getCSSColorforTask(approvalStatus);
  }
}
